module.exports = __webpack_public_path__ + "static/media/Logo_standard.8aee2e9d.svg";